var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('circle',{attrs:{"cx":"10","cy":"10","r":"10","fill":"#F5F4F8"}}),_c('path',{attrs:{"d":"M5 10L5.88125 10.8812L9.375 7.39375V15H10.625V7.39375L14.1125 10.8875L15 10L10 5L5 10Z","fill":"#4B2D88"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }